module.exports = __webpack_public_path__ + "files/fe030a26c83e1ec08846779d5d315acc.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-60x60.png
// module id = 1243
// module chunks = 76